export default "__VITE_ASSET__B5ye74zD__"